import {FormValues, IFilter} from "../../../types";
import {Button, Col, Container, Label} from "./styles";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import {useState} from "react";
import useGetMe from "../../../../../hooks/useCurrentUser";
import {DatePicker, Row} from "antd";
import {Field, Form, Formik} from "formik";
import Select from "antd/lib/select";
import moment, {Moment} from "moment";


export const FormFilter: React.FC<IFilter> = (props: IFilter) => {
  const {getFilters} = props
  const [isLoading] = useState<boolean>(false)
  const user = useGetMe();
  const {MonthPicker} = DatePicker;

  const getInitialValue = (): FormValues => {
    const today = new Date();
    return {
      month: today.getMonth() + 1,
      year: today.getFullYear(),
      merchantId: "",
      serialNumber: "",
      billingType: -1,
    };
  };

  const getBillings = async (submit: any) => {
    if (submit.month == "") {
      const today = new Date();
      const currentMonth = today.getMonth() + 1;
      submit.month = currentMonth;
    }

    if (submit.year == "") {
      const today = new Date();
      const currentYear = today.getFullYear();
      submit.year = currentYear;
    }

    getFilters(submit);
    return submit;
  }

  const handleMonthChange = (setFieldValue: (field: string, value: any) => void) =>
    (date: Moment | null) => {
      if (date) {
        setFieldValue('month', date.month() + 1);
        setFieldValue('year', date.year());
      } else {
        setFieldValue('month', '');
        setFieldValue('year', '');
      }
    };

  return(
    <Container style={{padding: "0px"}}>
      <LoadingOverlay show={isLoading} relative />

      <Row>
        <Label>Filtrar por:</Label>
      </Row>

      <Formik initialValues={getInitialValue()}
              onSubmit={async (values: any) => {
                await getBillings(values);
              }}
      >
        {({setFieldValue, values}) => (
          <Form>
            <Row gutter={16}>
                <MonthPicker
                  style={{width: "12.4rem", marginBottom: "0.8rem"}}
                  placeholder={"Selecione o mês e ano"}
                  format={"MM/YYYY"}
                  value={values.month && values.year ?
                    moment(`${values.year}-${values.month.toString().padStart(2, '0')}-01`) :
                    null}
                  onChange={handleMonthChange(setFieldValue)}
                  allowClear={true}
                />

              {(user.userType === 3 || user.userType === 6 || user.userType === 7) && (
                <Col>
                  <Field
                    type="text"
                    name="merchantId"
                    placeholder="Cód. Lojista"
                  />
                </Col>
              )}

              {/*<Col>*/}
              {/*  <Field*/}
              {/*    type="text"*/}
              {/*    name="serialNumber"*/}
              {/*    placeholder="Número de Série"*/}
              {/*  />*/}
              {/*</Col>*/}

              <Col>
                <Select
                  value={values.billingType}
                  style={{ width: "100%" }}
                  onChange={(value) => setFieldValue("billingType", value)}
                  options={[
                    {value: -1, label: "Produto"},
                    {value: 1, label: "POS Garantida"},
                    {value: 2, label: "Aluguel de POS"},
                    {value: 3, label: "PDV"}
                  ]}
                />
              </Col>

              <Col>
                <Button
                  htmlType="submit"
                >
                  Consultar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  )
}
